<template>
  <div v-if="dataWasDownloadedSuccessfully">

    <!-- Start Filter Tabs -->
    <div id="btnContainer" class="d-flex column-gap-1">
      <button class="btn btn-tag mb-2" v-for="year in years" :key="year" :class="{active : active_btn === year }"
        @click="activate(year)" v-on:click="filterSelection(year)">{{year}}</button>
      <button class="btn btn-tag mb-2" :class="{active : active_btn === 'all'}" @click="activate('all')"
        v-on:click="filterSelection('all')">Alles</button>
    </div>
    <!-- End Filter Tabs -->

    <!-- Start Articles -->
    <div class="blog-entries">
      <article v-for="(post, idx) in filteredPorts" class="my-5 filter-element animate__animated show animate__fadeInUp"
        :key="idx">
        <h4 class="mb-2">{{ post.fields.postTitle }}</h4>
        <small class="text-muted">{{ post.fields.postDate }}</small>
        <div class="mt-3">{{ post.fields.postDescription }}</div>
        <button id="open-button"  class="btn btn-text mt-2" v-on:click="openModal('modal');$emit('update-title', updateTitle($event))"
          :title="post.fields.postTitle">
          Weiterlesen <i class="icon-arrow-right"></i>
        </button>
      </article>
    </div>
    <!-- End Articles -->

    <!-- Start Blickpunkt Modal -->
    <div ref="modal" class="modal" id="modal">
      <button class="btn close-button" v-on:click="closeModal('modal')" id="close-button">
        <i class="icon-close"></i>
      </button>
      <div class="modal-content bg-brwn-lghtst p-0">
        <div class="modal--two-columns d-grid">
          <div class="modal--sidebar bg-brwn-lght">
            <div class="modal--sidebar-title p-4 text-xs-left mt-2">
              <small>Der GPP-Blickpunkt<!--{{ newsletterModalSidebarSubline }}--></small>
              <span class="h-4 mt-1">Regelmäßig mit wissenwerten Informationen versorgt werden!<!--{{ newsletterModalSidebarTitle }}--></span>
            </div>
          </div>

          <div class="modal--form px-4 px-lg-5 py-5 align-item-center text-xl-left">
            <form @submit.prevent="submitForm" class="d-grid column-gap-2 row-gap-2">
              <h4 class="id-title">Zum Blickpunkt anmelden<!--{{ newsletterModalHeading }}--></h4>
              <label class="control checkbox id-blickpunkt">
                <input v-model="form.gppFocus" type="checkbox">
                <span class="control-indicator"></span>
                <strong>GPP-Blickpunkte<!--{{ newsletterModalTitle1 }}--></strong>
                <br>
                <small><i>Erhalten Sie ihren ausgewählten Blickpunkt und alle zukünftigen Blickpunkte über aktuelle Themen, neueste Urteile und Neuregelungen.<!--{{ newsletterModalDescription1 }}--></i></small>
              </label>
              <label class="control checkbox id-newsletter mt-2">
                <input v-model="form.gppNewsletter" type="checkbox">
                <span class="control-indicator"></span>
                <strong>GPP-Newsletter<!--{{ newsletterModalTitle2 }}--></strong>
                <br>
                <small><i>Erhalten Sie neben dem GPP-Blickpunkt auch unseren monatlichen Newsletter.<!--{{ newsletterModalDescription2 }}--></i></small>
              </label>
              <div class="select id-salutation mt-3">
                <select v-model="form.salutation" aria-label="Anrede" required>
                  <option value="" disabled selected>Anrede*</option>
                  <option value="Frau">Frau</option>
                  <option value="Herr">Herr</option>
                </select>
              </div>
              <label class="id-name mt-lg-3">
                <input v-model="form.name" type="text" placeholder="Name*" required>
              </label>
              <label class="id-company">
                <input v-model="form.company" type="text" placeholder="Firma">
              </label>
              <label class="id-position">
                <input v-model="form.position" type="text" placeholder="Position">
              </label>
              <label class="id-email">
                <input v-model="form.email" type="email" placeholder="E-mail*" required>
              </label>
              <label class="control checkbox id-privacy mt-3">
                <input v-model="form.privacy" type="checkbox" aria-label="File browser example" required>
                <span class="control-indicator"></span>
                <small>
                  <span>Ich habe die <a href="/privacy" target="_blank"
                      title="Datenschutzerklärung anzeigen">Datenschutzerklärung</a> für Newsletter gelesen und erkläre
                    mich damit einverstanden.</span>
                </small>
              </label>
              <div class="id-submit">
                <div v-if="form.isCompleted" class="valid-feedback justify-self-center mt-3 d-none_">
                  Ihre Anmeldung wurde verschickt!
                </div>
                <input type="submit" :disabled="form.isCompleted" class="btn btn-primary mt-3" value="Anmelden">
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- End Blickpunkt Modal -->

  </div>
</template>

<script>
  import { getContent } from '@/javascripts/contentful';
    import { load } from 'recaptcha-v3';

  import axios  from 'axios';
  import helpers from '../javascripts/helpers';

  // application/json is not supported by CORS
  axios.defaults.headers.post['Content-Type'] = 'text/plain';

  const recaptchaRenderParams = {
    explicitRenderParameters: {
      badge: 'bottomleft',
    },
  };

  export default {
    name: 'articlesApp',
    props: [
      "articles",
      "newsletterModalSidebarSubline",
      "newsletterModalSidebarTitle",
      "newsletterModalHeading",
      "newsletterModalTitle1",
      "newsletterModalDescription1",
      "newsletterModalTitle2",
      "newsletterModalDescription2"
    ],
    data() {
      return {
        active_btn: 'all',
        years: [],
        posts: [],
        filteredPorts: [],
        dataWasDownloadedSuccessfully: false,
        form: {
          email: '',
          formName: 'Blickpunkt',
          name: '',
          company: '',
          salutation: '',
          position: '',
          privacy: false,
          gppFocus: false,
          title: '',
          gppNewsletter: false,
          isSending: false,
          isCompleted: false,
          isFailed: false,
        }
      }
    },
    async mounted() {
      const { fields } = await getContent(this.articles.sys.id)

      if (fields) {
        this.posts = [...fields.post];
        this.dataWasDownloadedSuccessfully = true
        _.each(this.posts, (post) => {
          this.years.push(new Date(post.fields.postDate).getFullYear())
        })

        this.years = _.uniq(this.years)
        const mostRecentYear = Math.max(...this.years.map(o => o), 0);
        if (mostRecentYear) {
          this.active_btn = Math.max(...this.years.map(o => o), 0)
          this.filteredPorts = this.posts.filter(post => new Date(post.fields.postDate).getFullYear() === mostRecentYear)
        } else {
          this.filteredPorts = this.posts
        }
      }
    },
    methods: {
      filterSelection(year) {
        if (year !== 'all') {
          this.filteredPorts = this.posts.filter(post => new Date(post.fields.postDate).getFullYear() === year)
        } else {
          this.filteredPorts = this.posts
        }
      },
      activate(el) {
        this.active_btn = el;
      },
      openModal(evt) {
        this.$refs[evt].classList.toggle('open')
        this.$refs[evt].classList.toggle('closed')
      },
      closeModal(evt) {
        this.$refs[evt].classList.toggle('closed')
        this.$refs[evt].classList.toggle('open')
      },
      updateTitle(evt) {
        this.form.title = evt.target.getAttribute('title')
      },
      submitForm() {
        if (this.form.isSending || this.form.isCompleted) {
          return;
        }
        this.form.isSending = true;

        load(process.env.GRECAPTCHA_SITE_KEY, recaptchaRenderParams)
          .then((recaptcha) => {
            recaptcha.execute('homepage').then((token) => {
              const formData = helpers.extractFromData(this.form, token);
              axios
                .post(process.env.FORM_TARGET_URL, JSON.stringify(formData))
                .then(() => {
                  this.form.isCompleted = true;
                })
                .catch(() => {
                  this.form.isFailed = true;
                })
                .finally(() => {
                  this.form.isSending = false;
                });
            });
          });
      }
    }
  }
</script>
